module.exports = __webpack_public_path__ + "static/timetravel_img5jpg-77aaffeb1b8b23c925d26152c62cf748.png";